<template>
  <ets-structure>
    <ets-sidebar v-if="userPermissions" slot="sidebar" :sections="sections"></ets-sidebar>
    <router-view />
  </ets-structure>
</template>

<script>
import { mapState } from "vuex";
import compliance from "@/logic/api/compliance";

export default {
  name: "LayoutAside",
  data: () => ({
    auth: null,
    entityType: null
  }),
  created() {
    compliance.getCorporateData().then(response => (this.entityType = response.data.entityType));
  },
  computed: {
    ...mapState(["userPermissions"]),
    sections() {
      let tramite_efs;
      let tramite_solvency;
      if (this.entityType == "SAV") {
        tramite_efs = {
          name: "Trámite EFS (EEFF)",
          url: "/eeff",
          isRouterLink: true,
          isDisabled: !this.userPermissions.EAFI_E_ProcedureCAE
        };
        tramite_solvency = {
          name: "Trámite EFS (Solvencia)",
          url: "/solvencyav",
          isRouterLink: true,
          isDisabled: !this.userPermissions.EAFI_E_ProcedureSEAFI
        };
      } else {
        tramite_efs = {
          name: "Trámite EFS (EEFF)",
          url: "/eeff",
          isRouterLink: true,
          isDisabled: !this.userPermissions.EAFI_E_ProcedureCAE
        };
        tramite_solvency = {
          name: "Trámite EFS (Solvencia)",
          url: "/solvency",
          isRouterLink: true,
          isDisabled: !this.userPermissions.EAFI_E_ProcedureSEAFI
        };
      }

      return [
        {
          title: this.entityType,
          links: [
            {
              name: "Registro de Clientes",
              url: "/clients",
              isRouterLink: true,
              isDisabled: !this.userPermissions.login
            },
            {
              name: "Registro de Servicios",
              url: "/services",
              isRouterLink: true,
              isDisabled: !this.userPermissions.login
            },
            {
              name: "Registro de Recomendaciones",
              url: "/recommendations",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_AXE_Recos
            },
            {
              name: "Registro de Ordenes",
              url: "/orders",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_AXE_Recos
            },
            {
              name: "Registro de Operaciones",
              url: "/trades",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_AXE_Recos
            },
            {
              name: "Registro de Posiciones",
              url: "/positions",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_AXE_Recos
            },
            tramite_solvency,
            {
              name: "Trámite EFS Consolidado (Solvencia)",
              url: "/solvencyconsolidated",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_E_ProcedureSEAFI
            },
            tramite_efs,
            {
              name: "Trámite IRE",
              url: "/ire",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_E_ProcedureIRE
            },
            {
              name: "Trámite CAE",
              url: "/cae",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_E_ProcedureCAE
            },
            {
              name: "Trámite ICI",
              url: "/ici",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_E_ProcedureICI
            },
            {
              name: "Otros trámites",
              url: "/others",
              isRouterLink: true,
              isDisabled: !this.userPermissions.EAFI_E_OtherProcedures
            }
          ]
        }
      ];
    }
  }
};
</script>
